import {
  Component, EventEmitter, HostListener, Input, OnInit,/*  */
  Output
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";

import { AuthService } from "app/services/user/auth.service";
import { Campaign3Campaign, DistributionCluster3, DistributionList3, DistributionListCluster, DistributionListDetails } from "app/views/campaign-3/models/campaign-3.model";
import { ActionStateService } from "app/views/campaign-3/services/actionstate.service";
import { Campaign3TestService } from "app/views/campaign-3/services/campaign3testservice";
import { DistributionList3Service } from "app/views/distribution-list/services/distribution3.service";
import { ChallengeDetail, ChallengeDetailElaborated, ChallengeResponse } from "../challenge.model";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { ChallengeService } from "../challenge.service";
import { MessageService } from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from "app/views/notification/services/notification-service.service";
import { ScheduleResponse } from "app/views/notification/model/notification-model";


@Component({
  selector: 'app-challenge-levels',
  templateUrl: './challenge-levels.component.html',
  styleUrls: ['./challenge-levels.component.css']
})
export class ChallengeLevels implements OnInit {

  /* =======================
   *       INPUT / OUTPUT
   * ======================= */
  @Input() actionData;
  @Input() fatherChallenge: ChallengeResponse;
  @Input() challengeDetailList: ChallengeDetail[];
  @Input() challengeDetailListElaborated: ChallengeDetailElaborated[];

  @Output() refreshCampaignActions = new EventEmitter();
  @Output() refreshChallengeLevels = new EventEmitter<any>();

  /* =======================
   *       PROPERTIES
   * ======================= */
  levelToDelete: any;
  displayDeleteDialog = false;

  menuCreationActive = false;
  showMenu = false;
  currentOpenedRow: number;

  actionTypes: Array<{ label: string; value: number; code: string }>;
  campaignList: Array<Campaign3Campaign> = [];
  singleAction: any;

  language = 'it';

  showNotificationStatusModal = false;
selectedNotificationRow: ScheduleResponse = null;
isLoadingNotification = false;

  protected readonly JSON = JSON;

  /* =======================
   *        SERVICES
   * ======================= */
  constructor(
    public router: Router,
    public testService: Campaign3TestService,
    public srvCalendar: CalendarTranslateService,
    public actionStateService: ActionStateService,
    public srvNotify: MessageService,
    public translate: TranslateService,
    private authService: AuthService,
    private challengeService: ChallengeService,
        private notificationService: NotificationService  // ← aggiungi

  ) { }

  /* =======================
   *        LIFECYCLE
   * ======================= */
  ngOnInit(): void {
    console.log(this.challengeDetailList);
    console.log(this.challengeDetailListElaborated);
  }

  /* =======================
   *      UTILITY METHODS
   * ======================= */
  onGetActionDescription(actionTypeId: number): string {
    const found = this.actionTypes && this.actionTypes.find(x => x.value === actionTypeId);
    return found ? found.label : 'ID not provided';
  }

  initMenuActivated(): void {
    // Resetta challengeDetailListElaborated
    if (this.challengeDetailListElaborated) {
      this.challengeDetailListElaborated.forEach(item => {
        item.menuActivated = false;
      });
    }

    // Resetta anche challengeDetailList se necessario
    if (this.challengeDetailList) {
      this.challengeDetailList.forEach(item => {
        item.menuActivated = false;
      });
    }
  }
  /* =======================
   *      DROPDOWN MENU
   * ======================= */
  toggleMenu(id: number, indexRow: number, event: Event): void {
    event.stopPropagation(); // IMPORTANTE: previeni la propagazione

    const current = this.challengeDetailListElaborated[indexRow];
    const previousValue = current.menuActivated;
    this.initMenuActivated();
    current.menuActivated = !previousValue;
    this.currentOpenedRow = id;
    this.showMenu = current.menuActivated;
  }

  /* =======================
   *     CLICK OUTSIDE
   * ======================= */
  @HostListener('document:click', ['$event'])
  onClick(event: any): void {
    const clickedOutsideMenu =
      !event.target.closest('.dropdown-menu') &&
      !event.target.closest('.btn-details');
    if (clickedOutsideMenu) {
      this.initMenuActivated();
      this.showMenu = false;
      this.currentOpenedRow = null;
    }
  }



  closeAllDropdowns(): void {
    this.initMenuActivated();
    this.showMenu = false;
    this.currentOpenedRow = null;
  }

  /* =======================
   *     NAVIGATION
   * ======================= */
  onSearchClusterToAdd(): void {
    let challengeId = null;

    if (
      this.fatherChallenge &&
      this.fatherChallenge.id !== undefined &&
      this.fatherChallenge.id !== null
    ) {
      challengeId = this.fatherChallenge.id;
    }

    if (challengeId !== null) {
      this.router.navigate(['/levels-creation'], { queryParams: { challengeId } });
    } else {
      console.error('Nessun challengeId disponibile, navigazione senza parametro');
    }
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log('Nessuna route implementata');
    }
  }



  /* =======================
   *      DIALOG HANDLING
   * ======================= */
  closePopupDelete(): void {
    this.displayDeleteDialog = false;
  }

  /* =======================
   *       DELETE LEVEL
   * ======================= */
  onDeleteLevel(challenge: any, index: number): void {
    console.log('index:', index);
    this.levelToDelete = challenge;
    this.displayDeleteDialog = true;
  }

  onDefinitiveDelete(): void {
    const levelToDelete = this.levelToDelete;

    if (!levelToDelete || !levelToDelete.id) {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('challenge.level_delete_invalid_id'),
        life: 5000
      });
      return;
    }

    const levelId = levelToDelete.id;
    const self = this;

    this.challengeService.deleteChallengeDetail(levelId).subscribe({
      next(): void {
        self.displayDeleteDialog = false;

        self.srvNotify.add({
          severity: 'success',
          summary: self.translate.instant('common.success'),
          detail: self.translate.instant('challenge.level_delete_success'),
          life: 5000
        });

        self.refreshChallengeLevels.emit(self.fatherChallenge);
      },

      error(err): void {
        console.error('Errore durante la cancellazione:', err);

        self.srvNotify.add({
          severity: 'error',
          summary: self.translate.instant('common.error'),
          detail: self.translate.instant('challenge.level_delete_error'),
          life: 5000
        });
      }
    });
  }

  /* =======================
   *       EDIT LEVEL
   * ======================= */
onEditLevel(level: ChallengeDetailElaborated): void {
  this.router.navigate(['/levels-creation'], {
    queryParams: {
      challengeId: level.challengeId,
      id: level.id,
      readOnly: false
    }
  });
}

onInfoLevel(level: ChallengeDetailElaborated): void {
  this.router.navigate(['/levels-creation'], {
    queryParams: {
      challengeId: level.challengeId,
      id: level.id,
      readOnly: true
    }
  });
}



  onEditGifts(level: ChallengeDetailElaborated): void {
    this.router.navigate(['/gifts-creation'], {
      queryParams: {
        challengeId: level.challengeId,
        levelId: level.id
      }
    });
  }


  /* =======================
   *     STUB METHODS
   * ======================= */
  checkExpiredChallengeDetail(): string {
    return '';
  }

isEditLevelDisabled(): boolean {
    const challenge = this.fatherChallenge;
    let disabled = true; // default totale di sicurezza

    if (challenge) {
        const status = challenge.status ? Number(challenge.status) : null;
        const dateStart = challenge.dateStart ? new Date(challenge.dateStart) : null;
        const now = new Date();

        // 1. Stato 0 → Pubblicata → sempre disabilitata
        if (status === 0) {
            disabled = true;

        // 2. Stato 4 → Pubblicazione annullata
        } else if (status === 4) {
            if (dateStart) {
                if (now >= dateStart) {
                    disabled = true;  // sfida iniziata → disabilitato
                } else {
                    disabled = false; // non iniziata → abilitato
                }
            } else {
                disabled = true; // niente data → sicurezza
            }

        // 3. Tutti gli altri stati → abilitato
        } else {
            disabled = false;
        }
    }

    return disabled;
}


isInfoLevelDisabled(){
  return false;
}


openNotificationStatus(row: any): void {
    this.closeAllDropdowns(); // usa il metodo che hai già invece di showMenu = false
    this.isLoadingNotification = true;
    this.notificationService.getNotificationDetail(row.challengeId).subscribe({ // ← challengeId
        next: (detail) => {
            this.selectedNotificationRow = detail;
            this.showNotificationStatusModal = true;
            this.isLoadingNotification = false;
        },
        error: (err) => {
            console.error('Errore caricamento stato notifica:', err);
            this.isLoadingNotification = false;
            this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('notification.load_error'),
                life: 5000
            });
        }
    });
}




}



// WEBPACK FOOTER //
// ./src/app/views/challenge/challeng-levels/challenge-levels.component.ts